import React from 'react';
import { Card } from '../ui/card';
import { Users, Zap, BookOpen, Target, Shield } from 'lucide-react';

export const OverviewTab = ({ analytics, campus }) => {
  if (!analytics) return null;
  const stats = [
    { label: 'Members', value: analytics.total_members, icon: Users, color: 'from-blue-500 to-cyan-500' },
    { label: 'Active This Week', value: analytics.active_this_week, icon: Zap, color: 'from-green-500 to-emerald-500' },
    { label: 'Lectures', value: analytics.total_lectures, icon: BookOpen, color: 'from-purple-500 to-indigo-500' },
    { label: 'Study Cards', value: analytics.total_learning_bytes, icon: Target, color: 'from-amber-500 to-orange-500' },
    { label: 'Exams Taken', value: analytics.total_exams, icon: Shield, color: 'from-red-500 to-rose-500' },
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {stats.map(s => (
          <Card key={s.label} className="p-4  bg-[var(--isp-glass)] backdrop-blur-xl border-[var(--isp-glass-border)]">
            <div className="flex items-center gap-3">
              <div className={`p-2 rounded-xl bg-gradient-to-br ${s.color}`}>
                <s.icon className="w-4 h-4 text-white" />
              </div>
              <div>
                <p className="text-2xl font-bold text-white">{s.value}</p>
                <p className="text-xs text-[var(--isp-body)]">{s.label}</p>
              </div>
            </div>
          </Card>
        ))}
      </div>
      <Card className="p-5  bg-[var(--isp-glass)] backdrop-blur-xl border-[var(--isp-glass-border)]">
        <h3 className="text-lg font-semibold text-[var(--isp-heading)] mb-2">Plan Utilization</h3>
        <div className="h-3 bg-[var(--isp-glass-inner)] rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-purple-500 to-indigo-500 rounded-full" style={{ width: `${analytics.utilization_pct}%` }} />
        </div>
        <p className="text-sm text-[var(--isp-body)] mt-2">
          {analytics.total_members}/{campus.max_users} seats used ({analytics.utilization_pct}%)
        </p>
      </Card>
    </div>
  );
};

export const MembersTab = ({ members }) => {
  if (!members) return null;
  return (
    <Card className="p-5  bg-[var(--isp-glass)] backdrop-blur-xl border-[var(--isp-glass-border)]">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-white">{members.total} Members</h3>
        <span className="text-xs text-[var(--isp-muted)]">{members.remaining_slots} slots remaining</span>
      </div>
      <div className="space-y-2">
        {members.members.map((m, i) => (
          <div
            key={m.user_id || `member-${i}`}
            className="flex items-center gap-3 p-3 rounded-xl bg-slate-800/30 border border-[var(--isp-glass-border)]"
            data-testid={`member-${i}`}
          >
            <div className="w-9 h-9 rounded-full bg-purple-500/20 flex items-center justify-center text-sm font-bold text-purple-300">
              {(m.name || m.email || '?')[0].toUpperCase()}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-[var(--isp-heading)] truncate">{m.name || 'Unknown'}</p>
              <p className="text-xs text-[var(--isp-muted)] truncate">{m.email}</p>
            </div>
            {m.campus_role === 'admin' && (
              <span className="text-xs px-2 py-1 rounded-md bg-purple-500/20 text-purple-300">Admin</span>
            )}
          </div>
        ))}
      </div>
    </Card>
  );
};
